// Note - created/modified etc omitted from diagram, but in everything user created
// Note - assets have description for sure, but folders having one is TBH
// Related `content-folders-and-assets.sql`: https://github.com/relationshipone/r1-tfs-compass-config/blob/cloud-9319/sql/2024-01-19.content-folders-and-assets.sql#L1C1-L1C36
// Also see Java models

import { DataMartField, DataMartMergeField } from '@r1-compass-library/models';

export type BasicMetadata = {
    id: number;
    updatedAt: Date;
    updatedBy: number;
    createdAt: Date;
    createdBy: number;
    lastConfigured?: Date;
};

export type DivisionItemMetadata = {
    iamDivisionId: number;
    name: string;
} & BasicMetadata;

// Folders ============================

export type BasicFolder = {
    path: string;
    parentFolder?: BasicFolder;
    parentFolderId: number;
} & DivisionItemMetadata;

export type ContentAssetFolder = {
    type: 'Content';
} & BasicFolder;

export type LifecycleRulesetFolder = {
    type: 'LifeCycle';
} & BasicFolder;

export type PlayFolder = {
    type: 'Play';
} & BasicFolder;

export type TemplateCriteriaFolder = {
    type: 'TemplateCriteria';
} & BasicFolder;

// Assets =========================================

export type AssetMetadata = {
    description?: string;
    folderId: number | null;
    deletedAt: Date | null;
    enabled?: boolean;
    valid?: boolean;
} & DivisionItemMetadata;

export type ContentAsset = {
    type: string;
    folder?: ContentAssetFolder;
    rules?: ContentAssetRule[];
    playImporterId?: number;
} & AssetMetadata;

export type PlayImporterCSVField = {
    name: string | undefined;
    dataType: 'integer' | 'varchar' | 'numeric' | 'date' | 'timestamptz' | undefined;
};

export type ContentAssetRule = {
    id?: string;
    name?: string;
    field?: DataMartField | PlayImporterCSVField;
    not?: boolean | null;
    comparator?: string | null;
    value?: string | null;
    talkingPointsTemplate?: string | null;
    dataMartFieldMerges?: DataMartMergeField[];
    importerFileHeaders?: string[];
    images?: string[];
};

export function isDatamartField(field: ContentAssetRule['field']): field is DataMartField {
    return !!(field as DataMartField)?.displayName;
}

export type Content = ContentAssetFolder | ContentAsset;

export function isFolder(arg: BasicFolder | AssetMetadata): arg is BasicFolder {
    return (arg as BasicFolder).parentFolderId !== undefined;
}

export function isContentFolder(arg: BasicFolder | AssetMetadata): arg is BasicFolder {
    return (arg as BasicFolder).parentFolderId !== undefined;
}

export function isAsset(arg: BasicFolder | AssetMetadata): arg is AssetMetadata {
    return (arg as AssetMetadata).folderId !== undefined;
}

// Use similar but not same endpoints - this is the plan on Mon Feb 12 w/Steve

// Whether it is a different endpoint or param, will be seperate way to get folders for sidenav. For now the seperate endpoint mocked up is fine.
// ID of an asset = "id", returns item JSON
// Key off of `folderId` for content and `parentFolderId` for folders - for list
//     On the list as an example for URL:
//         ---Actual Data example---
//         Data Endpoint (folders): compass/content-asset-folders (get ALL content asset folders, or root level)
//         Data Endpoint PATTERN: compass/${type}-folders (generic of above)

//         ---Actual Data example, like above chunk but play templates---
//         Data Endpoint PATTERN: compass/play-templates-folders (actual example, give all or at root with all data- Steve not sure)
//         Data Endpoint PATTERN: compass/play-templates (actual example, for Play Templates regardless of folders ?)
//         Unsure of how we specify particular ones at what level yet, param or not

//         ---Generic by ID + 2 examples (1 for folders in the ID, 1 for assets in the ID) ---
//         Data Endpoint PATTERN: compass/${type}-folders/${id}/${type} (list of things at folder of type at folder with ID)
//         Data Endpoint PATTERN: compass/play-templates-folders/1/play-templates (actual example of getting play tempaltes under 1)
//         Data Endpoint PATTERN: compass/play-templates-folders/1/folders (actual example of getting play template folders under 1)

//         ---Main pattern, not including the root folders or asset/type---
//         Data Endpoint:

//         List stuff in folder B - 2 endpoints (like the above generic + 2 examples chunk):
//         /${type}-folders/${id}/folders
//         and
//         /${type}-folders/${id}/${type} (or instead of assets be `/plays`, unsure now), and ${type} could just be "assets"
//
//         Route URL: List stuff in folder B - 2 endpoints: /${type}?folderId=${id}

// Steve Feb 13
// it would be like GET /plays/1, which would load all the play information,
// and then once loaded the route url could default to the first section, definition, and be like /plays/1/definition
